import { Insurer } from 'BrokerTsLib/src/enums'
export type ICompany = {
  id: number
  name: string
  //businessDiscounts?: any
}

export const companies: Array<ICompany & { businessDiscounts?: any }> = [
  {
    id: Insurer.Allianz,
    name: 'Allianz',
    businessDiscounts: {
      chaloupka: {
        'Obchodní sleva': {
          min: '0%',
          max: '30%',
        },
      },
    },
  },
  {
    id: Insurer.CPP,
    name: 'ČPP',
    businessDiscounts: {
      carkulka: {
        HAV: {
          min: '0%',
          max: '20%',
        },
        POV: {
          min: '0%',
          max: '20%',
        },
      },
      chaloupka: {
        'Obchodní sleva': {
          min: '0%',
          max: '20%',
        },
      },
    },
  },
  {
    id: Insurer.Csob,
    name: 'ČSOB pojišťovna',
    businessDiscounts: {
      carkulka: {
        Smlouva: {
          min: '0%',
          max: '20%',
        },
      },
      chaloupka: {
        'Obchodní sleva': {
          min: '0%',
          max: '20%',
        },
      },
    },
  },
  {
    id: Insurer.Direct,
    name: 'Direct pojišťovna',
    businessDiscounts: {
      carkulka: {
        POV: {
          min: '0%',
          max: '10%',
        },
      },
    },
  },
  {
    id: Insurer.GeneraliCeskaPojistovna,
    name: 'Generali Česká pojišťovna',
    businessDiscounts: {
      carkulka: {
        HAV: {
          min: '0%',
          max: '40%',
        },
        POV: {
          min: '0%',
          max: '40%',
        },
      },
      chaloupka: {
        'Obchodní sleva': {
          min: '0%',
          max: '20%',
        },
      },
    },
  },
  {
    id: Insurer.HvP,
    name: 'HVP',
    businessDiscounts: {
      carkulka: {
        Smlouva: {
          min: '0%',
          max: '20%',
        },
      },
    },
  },
  {
    id: Insurer.Kooperativa,
    name: 'Kooperativa',
    businessDiscounts: {
      carkulka: {
        HAV: {
          min: '0%',
          max: '25%',
        },
        POV: {
          min: '0%',
          max: '30%',
        },
      },
    },
  },
  {
    id: Insurer.Pillow,
    name: 'Pillow',
  },
  {
    id: Insurer.PVZP,
    name: 'VZP pojišťovna',
    businessDiscounts: {
      carkulka: {
        HAV: {
          min: '0%',
          max: '20%',
        },
        POV: {
          min: '0%',
          max: '20%',
        },
      },
    },
  },
  {
    id: Insurer.Slavia,
    name: 'Slavia pojišťovna',
    businessDiscounts: {
      carkulka: {
        Provize: {
          min: '1%',
          max: '50%',
        },
      },
    },
  },
  {
    id: Insurer.Uniqa,
    name: 'Uniqa pojišťovna',
    businessDiscounts: {
      carkulka: {
        HAV: {
          min: '0%',
          max: '20%',
        },
        POV: {
          min: '0%',
          max: '10%',
        },
      },
    },
  },
  {
    id: Insurer.Axa,
    name: 'Uniqa AXA pojišťovna',
    businessDiscounts: {
      carkulka: {
        Provize: {
          min: '1%',
          max: '10%',
        },
      },
    },
  },
  {
    id: Insurer.Fortegra,
    name: 'Fortegra',
    businessDiscounts: {
      carkulka: {
        Provize: {
          min: '1%',
          max: '10%',
        },
      },
    },
  },
]

const carkulkaCompaniesList: Array<number> = [
  Insurer.Allianz,
  Insurer.CPP,
  Insurer.Csob,
  Insurer.Direct,
  Insurer.Generali,
  Insurer.HvP,
  Insurer.Kooperativa,
  Insurer.Pillow,
  Insurer.PVZP,
  Insurer.Slavia,
  Insurer.Uniqa,
  Insurer.Axa,
]


const carkulkaExtraCompaniesList: Array<number> = [
  Insurer.Fortegra
]
const chaloupkaCompaniesList: Array<number> = [
  Insurer.Allianz,
  Insurer.CPP,
  Insurer.Csob,
  Insurer.Direct,
  Insurer.Generali,
  Insurer.Kooperativa,
  Insurer.Uniqa,
  Insurer.Axa,
]

const smeCompaniesList: Array<number> = [
  Insurer.CPP,
  Insurer.Csob,
  Insurer.Direct,
  Insurer.Slavia
]

const cestovkoCompaniesList: Array<number> = [
  Insurer.Allianz,
  Insurer.CPP,
  Insurer.Csob,
  Insurer.Direct,
]

const filterCompaniesByApp = (list: Array<number>) => {
  // Vyfiltruje všechny companies, jejichž id je obsazženo v list
  return companies.filter((company) => {
    return list.includes(company.id)
  })
}

export const getCompanyNameById = (id?: ICompany['id']) => {
  const company = companies.find((company) => company.id === id)

  return company?.name
}

export const carkulkaCompanies: Array<ICompany> = filterCompaniesByApp(carkulkaCompaniesList)
export const carkulkaExtraCompanies: Array<ICompany> = filterCompaniesByApp(carkulkaExtraCompaniesList)
export const chaloupkaCompanies: Array<ICompany> = filterCompaniesByApp(chaloupkaCompaniesList)
export const smeCompanies: Array<ICompany> = filterCompaniesByApp(smeCompaniesList)
export const cestovkoCompanies: Array<ICompany> = filterCompaniesByApp(cestovkoCompaniesList)
